<div class="field-grid">
    <div class="field-main">
        <ng-content></ng-content>
        <div class="field-right">
            <ng-content select="[top]"></ng-content>
        </div>
    </div>
    <ng-content select="[bottom]"></ng-content>
</div>
